import styled, { css } from "styled-components";

const fontStyles = css`
  font-family: "Lato";
  line-height: 1;
  font-size: 1rem;
`;

export const Title = styled.h2`
  font-family: Lato;
  font-style: normal;
  color: #00aeea;
  font-weight: 600;
  letter-spacing: 0;
  text-align: left;
  font-size: 16px;
  text-transform: initial;
  line-height: 1;
  margin: 10px 0 -5px 0;
`;

export const SolutionListItemOuter = styled.div`
  box-shadow: 0 4px 4px rgb(0 0 0 / 25%);
  border: 1px solid #008395;
  border-radius: 4px;
`;

export const SolutionListItem = styled.div`
  padding: 10px 15px;
  border-bottom: 1px solid #cccccc;
`;

export const SolutionListItemTitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
`;

export const SolutionListItemTitle = styled.h2`
  color: ${(props) => (props?.color ? props.color : "#0a4986")};
  display: inline-block;
  font-family: Lato;
  font-size: ${(props) => (props?.fontSize ? props.fontSize : "16px")};
  font-style: normal;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 16px;
  margin: 0 0 5px;
  text-align: left;
`;

export const SolutionListItemPriceWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  width: 100%;
`;

export const SolutionListItemPrice = styled.div`
  display: grid;
  grid-template-columns: 50% 20% 1fr;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  margin-right: 10px;
  width: 100%;
`;

export const SolutionListItemPriceLabel = styled.span`
  font-family: Lato;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 16px;
  text-align: left;
  color: ${(props) => (props?.color ? props.color : "#767676")};
  margin: 0 5px 0 0;
  width: 100%;
`;

export const SolutionListItemPriceValue = styled.span`
  font-family: Lato;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 16px;
  text-align: left;
  color: ${(props) => (props?.color ? props.color : "#767676")};
  font-style: ${(props) => (props?.fontStyle ? props.fontStyle : "normal")};
  margin: 0 5px 0 0;
  width: 100%;
  text-align: ${(props) => (props?.textAlign ? props.textAlign : "left")};
`;

export const UnitPriceInput = styled.input`
  width: 5.125rem;
  border: 1px solid #ff981e;
  font-size: 1rem;
  line-height: 1;
  font-family: "Lato";
  outline: none;
  &:hover,
  &:focus {
    border: 1px solid #ff981e !important;
  }
`;

export const GridOuterPriceType = styled.div`
  display: grid;
  grid-template-columns: 80% auto;
`;

export const AllocationParent = styled.div`
  margin-top: -13px;
`;

export const AllocationQuantity = styled.span`
  font-family: Lato;
  font-size: 12px;
  font-style: normal;
  line-height: 16px;
  color: #767676;
  display: grid;
  grid-template-columns: 1fr;
  text-align: center;
  width: 130px;
`;

export const RequiredMessagePara = styled.p`
  margin: 0px 0 0px;
  text-align: center;
  color: red;
`;

export const GridPurchasePriceType = styled.div`
  display: grid;
  grid-template-columns: 50% auto;
`;

export const PurchasePriceValue = styled.span`
  font-family: "Lato";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 1;
  margin-left: 0.5rem;
  color: ${(props) => props.color};
`;

export const EstimatedPurchasePriceLabel = styled.span`
  font-family: Lato;
  font-size: 14px;
  font-style: italic;
  font-weight: 400;
  line-height: 16px;
  text-align: right;
  color: #767676;
  float: right;
`;

export const NoSolution = styled.p`
  font-size: ${(props) => props.fontSize ?? "14px"};
  font-weight: 400;
  margin: 0 0 15px;
  font-family: "Lato";
  color: #767676;
  line-height: 1;
  text-transform: initial;
  font-style: italic;
`;

export const NoSolutionOuter = styled.div`
  padding: 10px 15px;
`;

export const ToggleGridOuter = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 1rem;
`;
export const SolutionToggleLabel = styled.span`
  font-family: Lato;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 16px;
  text-align: left;
  color: "#767676";
  margin: 5px 5px 0 0;
  width: 100%;
`;

export const UppEmpty = styled.span`
  color: #f08046;
`;

export const CommentText = styled.span`
  font-family: Lato;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 16px;
  text-align: left;
  color: ${(props) => (props?.color ? props.color : "#767676")};
  margin: 0 5px 0 0;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding-left: 4px;
  cursor: pointer;
`;

export const ToolTipCommentText = styled.p`
  font-size: 16px;
  line-height: 22px;
  font-family: Lato;
  margin: 0 0 5px 0px;
  text-align: left;
  color: #767676;
`;

export const ToolTipCommentsWrapper = styled.div`
  background-color: #fff !important;
  padding: 5px;
`;

export const DivToolTipCustom = {
  maxWidth: "40rem",
  wordBreak: "break-all",
  overflowWrap: "break-word",
  display: "block",
  zIndex: 99999,
  padding: "2px",
  borderRadius: "3px",
  minWidth: "35rem",
  background: "#004C7F",
  backgroundColor: "#004C7F",
};
